import React from 'react';
import { Show } from '@refinedev/antd';
import { useShow } from '@refinedev/core';
import { Table, Tag, theme } from 'antd';
import { AdminSurveyResponseDetailDto, ResponseStatus } from '@wellverse/shared-ts';
import { Field } from '../../components/Field';

const statusColors: Record<ResponseStatus, string> = {
  [ResponseStatus.IN_PROGRESS]: '#f5a623',
  [ResponseStatus.COMPLETED]: '#3ecf8e',
  [ResponseStatus.ABANDONED]: '#ff6b6b',
};

export const SurveyResponseShow: React.FC = () => {
  const { token } = theme.useToken();
  const { queryResult } = useShow<AdminSurveyResponseDetailDto>({ resource: 'survey-responses' });
  const item = queryResult?.data?.data;

  if (!item) {
    return <div style={{ color: token.colorTextSecondary }}>Loading...</div>;
  }

  return (
    <Show resource="survey-responses">
      <div style={{ padding: '8px 0' }}>
        <Field label="Survey">{item.surveyName}</Field>
        <Field label="User ID">{item.userId}</Field>
        <Field label="Status">
          <Tag
            style={{
              borderColor: statusColors[item.status] || '#898989',
              color: statusColors[item.status] || '#898989',
              background: `${statusColors[item.status] || '#898989'}15`,
              borderRadius: 9999,
              padding: '2px 12px',
              fontWeight: 500,
            }}
          >
            {item.status}
          </Tag>
        </Field>
        <Field label="Current Screen Index">{item.currentScreenIndex}</Field>
        <Field label="Started At">{new Date(item.startedAt).toLocaleString()}</Field>
        {item.completedAt && (
          <Field label="Completed At">{new Date(item.completedAt).toLocaleString()}</Field>
        )}
      </div>

      <h3 style={{ color: token.colorText, margin: '24px 0 16px' }}>Answers</h3>
      <Table
        dataSource={item.answers}
        rowKey="id"
        pagination={false}
        size="small"
      >
        <Table.Column dataIndex="questionKey" title="Question Key" />
        <Table.Column dataIndex="questionText" title="Question Text" />
        <Table.Column
          dataIndex="answerValue"
          title="Answer"
          render={(value: string) => {
            try {
              const parsed = JSON.parse(value);
              if (Array.isArray(parsed)) {
                return parsed.join(', ');
              }
              return String(parsed);
            } catch {
              return value;
            }
          }}
        />
        <Table.Column
          dataIndex="answeredAt"
          title="Answered At"
          render={(date: string) => (date ? new Date(date).toLocaleString() : '—')}
        />
      </Table>
    </Show>
  );
};
